import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './ProgressBar.styles';

var buildSegments = function buildSegments(number, color, opacity) {
  var segments = [];

  for (var index = 1; index < number; index += 1) {
    segments.push( /*#__PURE__*/React.createElement(Styled.SegmentDivider, {
      key: index,
      position: 100 * (index / number),
      color: color,
      opacity: opacity
    }));
  }

  return segments;
};

var ProgressBar = function ProgressBar(_ref) {
  var value = _ref.value,
      scale = _ref.scale,
      height = _ref.height,
      color = _ref.color,
      segmentDividerColor = _ref.segmentDividerColor,
      segmentDividerOpacity = _ref.segmentDividerOpacity,
      numberOfSegments = _ref.numberOfSegments,
      showCount = _ref.showCount,
      maxCountOffset = _ref.maxCountOffset,
      dataTest = _ref['data-test'],
      ariaLabel = _ref['aria-label'];
  var countLength = maxCountOffset || value.toString().length;
  var segments = buildSegments(numberOfSegments, segmentDividerColor, segmentDividerOpacity);
  var cappedValue = value < scale ? value : scale;
  var widthOfBar = "".concat(cappedValue / scale * 100, "%");
  var widthOfBarRounded = "".concat((cappedValue / scale).toFixed(2) * 100, "%");
  return /*#__PURE__*/React.createElement(Styled.Container, {
    "data-test": dataTest,
    "data-value": cappedValue,
    "data-percentage": widthOfBar,
    "aria-label": "".concat(ariaLabel, " at ").concat(widthOfBarRounded),
    role: "figure"
  }, /*#__PURE__*/React.createElement(Styled.BarContainer, {
    height: height
  }, /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "".concat(cappedValue, " of ").concat(scale)), /*#__PURE__*/React.createElement(Styled.Bar, {
    height: value && height,
    color: color,
    width: widthOfBar
  }), segments), showCount && /*#__PURE__*/React.createElement(Styled.Count, {
    width: countLength,
    lineHeight: height,
    "data-test": "".concat(dataTest, "-count"),
    "data-offset": countLength
  }, value));
};

ProgressBar.defaultProps = {
  value: 0,
  scale: 100,
  height: 8,
  color: 'yellow',
  segmentDividerColor: 'dark',
  numberOfSegments: 1,
  segmentDividerOpacity: 0.3,
  showCount: true,
  maxCountOffset: 0,
  'data-test': 'component-progress-bar',
  'aria-label': 'Progress Bar'
};
ProgressBar.propTypes = {
  /**
   * Required prop to specify the value to be displayed on the bar
   */
  value: PropTypes.number,

  /**
   * Optional: Specify the scale of the bar
   */
  scale: PropTypes.number,

  /**
   * Optional: Specify the height of the bar
   */
  height: PropTypes.number,

  /**
   * Optional: Specify the colour of the bar (Default: yellow)
   */
  color: PropTypes.string,

  /**
   * Optional: Specify the colour of the lines separating each segment in the bar (Default: dark)
   */
  segmentDividerColor: PropTypes.string,

  /**
   * Optional: Specify the opacity of the lines separating each segment in the bar
   */
  segmentDividerOpacity: PropTypes.number,

  /**
   * Optional: Specify an optional number of segments to be added
   */
  numberOfSegments: PropTypes.number,

  /**
   * Optional: Specify whether a count should be displayed
   */
  showCount: PropTypes.bool,

  /**
   * Specify the max count value so other progress bars have same offset (only needed if using multiple stacked bars, default: disabled)
   */
  maxCountOffset: PropTypes.number,

  /**
   * Specify an optional data-test attribute to be added for e2e testing
   */
  'data-test': PropTypes.string,

  /**
   * Specify an aria-label attribute for screen readers
   */
  'aria-label': PropTypes.string
};
export default ProgressBar;